<template>
  <div id="classDetailsDiv">
    <div class="classDetailsDiv_content">
      <div class="head_title class_head_title">
        <div class="head_title_font class_head_title_font">考勤情况&gt;</div>
      </div>
      <div class="body_content class_body_content">



        <div class="class_body_content_self">
          <table class="table table-striped table-bordered">
            <tbody>
            <tr>
              <th>序号</th>
              <th>学员姓名</th>
              <th>已上课程</th>
              <th>迟到次数</th>
              <th>早退次数</th>
              <th>旷课次数</th>
              <th>请假次数</th>
              <th>详情</th>
            </tr>
            <tr>
              <td>1</td>
              <td>王四三</td>
              <td>201</td>
              <td>4</td>
              <td>34</td>
              <td>45</td>
              <td>3</td>
              <td>
                <div class="details_pic" data-toggle="modal" data-target="#myModal"></div>
              </td>
            </tr>
            <tr>
              <td>1</td>
              <td>王四三</td>
              <td>201</td>
              <td>4</td>
              <td>34</td>
              <td>45</td>
              <td>3</td>
              <td>
                <div class="details_pic" data-toggle="modal" data-target="#myModal"></div>
              </td>
            </tr>
            <tr>
              <td>1</td>
              <td>王四三</td>
              <td>201</td>
              <td>4</td>
              <td>34</td>
              <td>45</td>
              <td>3</td>
              <td>
                <div class="details_pic" data-toggle="modal" data-target="#myModal"></div>
              </td>
            </tr>
            <tr>
              <td>1</td>
              <td>王四三</td>
              <td>201</td>
              <td>4</td>
              <td>34</td>
              <td>45</td>
              <td>3</td>
              <td>
                <div class="details_pic" data-toggle="modal" data-target="#myModal"></div>
              </td>
            </tr>
            <tr>
              <td>1</td>
              <td>王四三</td>
              <td>201</td>
              <td>4</td>
              <td>34</td>
              <td>45</td>
              <td>3</td>
              <td>
                <div class="details_pic" data-toggle="modal" data-target="#myModal"></div>
              </td>
            </tr>
            <tr>
              <td>1</td>
              <td>王四三</td>
              <td>201</td>
              <td>4</td>
              <td>34</td>
              <td>45</td>
              <td>3</td>
              <td>
                <div class="details_pic" data-toggle="modal" data-target="#myModal"></div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

      </div>
    </div>
    <!-- 模态框（Modal） -->
    <div class="modal fade" id="myModal" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-hidden="true">&times;</button>
            <h4 class="modal-title" id="myModalLabel">学员考勤详情_王四三</h4>
          </div>
          <div class="modal-body">
            <table class="table table-striped table-bordered">
              <tbody>
              <tr>
                <th>日期</th>
                <th>课程名称</th>
                <th>考勤情况</th>
              </tr>
              <tr>
                <td>2019/01/16</td>
                <td>党性教育1</td>
                <td>迟到</td>
              </tr>
              <tr>
                <td>2019/01/16</td>
                <td>党性教育1</td>
                <td>迟到</td>
              </tr>
              <tr>
                <td>2019/01/16</td>
                <td>党性教育1</td>
                <td>迟到</td>
              </tr>
              <tr>
                <td>2019/01/16</td>
                <td>党性教育1</td>
                <td>迟到</td>
              </tr>
              <tr>
                <td>2019/01/16</td>
                <td>党性教育1</td>
                <td>迟到</td>
              </tr>
              <tr>
                <td>2019/01/16</td>
                <td>党性教育1</td>
                <td>迟到</td>
              </tr>
              <tr>
                <td>2019/01/16</td>
                <td>党性教育1</td>
                <td>迟到</td>
              </tr>
              <tr>
                <td>2019/01/16</td>
                <td>党性教育1</td>
                <td>迟到</td>
              </tr>

              </tbody>
            </table>
          </div>
        </div><!-- /.modal-content -->
      </div><!-- /.modal -->
    </div>
  </div>
</template>

<script>
    export default {
        name: "attendanceSituation"
    }
</script>

<style scoped>
  @import '../assets/css/plugins.css';
  @import "../assets/css/publicStyle.css";
  @import "../assets/css/teachingEvaluation.css";
</style>



// WEBPACK FOOTER //
// src/components/attendanceSituation.vue